import React from 'react';
import { Card, Button } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

/**
 * Shown after Stripe redirects back to /registration/success.
 * Must show NO sensitive data — account creation already happened in the webhook.
 */
const RegistrationSuccess: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div style={styles.page}>
      <Card style={styles.card} bordered={false}>
        <CheckCircleOutlined style={styles.icon} />

        <h1 style={styles.title}>Payment successful!</h1>

        <p style={styles.body}>
          Your account is being set up. Check your email for your login details —
          it may take a minute to arrive.
        </p>

        <div style={styles.infoBox}>
          <strong>What happens next?</strong>
          <ul style={styles.list}>
            <li>You will receive an email with a temporary password.</li>
            <li>Log in and you will be prompted to set a new password.</li>
            <li>Your Business License is active from today.</li>
          </ul>
        </div>

        <Button
          type="primary"
          size="large"
          style={styles.button}
          onClick={() => navigate('/login')}
        >
          Go to Login
        </Button>

        <p style={styles.support}>
          Didn't receive an email?{' '}
          <a href="mailto:support@shahosuite.com">Contact support</a>.
        </p>
      </Card>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  page: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '40px 20px',
  },
  card: {
    maxWidth: 520,
    width: '100%',
    borderRadius: 12,
    boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
    textAlign: 'center',
    padding: '32px 24px',
  },
  icon: {
    fontSize: 72,
    color: '#52c41a',
    marginBottom: 20,
    display: 'block',
  },
  title: {
    fontSize: 26,
    fontWeight: 700,
    color: '#1a1a2e',
    marginBottom: 12,
  },
  body: {
    fontSize: 15,
    color: '#444',
    marginBottom: 24,
    lineHeight: 1.6,
  },
  infoBox: {
    background: '#f6ffed',
    border: '1px solid #b7eb8f',
    borderRadius: 8,
    padding: '16px 20px',
    textAlign: 'left',
    marginBottom: 28,
    fontSize: 14,
    color: '#333',
  },
  list: {
    margin: '8px 0 0 0',
    paddingLeft: 20,
    lineHeight: 1.8,
  },
  button: {
    height: 48,
    fontSize: 16,
    fontWeight: 700,
    borderRadius: 8,
    minWidth: 180,
  },
  support: {
    marginTop: 20,
    fontSize: 13,
    color: '#888',
  },
};

export default RegistrationSuccess;
